<template>
  <div>
    <v-form ref="form">
      <v-card class="form">
        <v-row
          v-for="(column, columnKey) in columns"
          :key="columnKey"
          align="center"
          v-show="column.Name != 'adminConfirmStatus'"
        >
          <template v-if="column.Name != 'adminConfirmStatus'">
            <v-col class="d-flex" cols="12" sm="6"
              ><b>
                {{
                  column.Title +
                  (column.Nullable || column.Type == "bool" ? "" : " *")
                }}
              </b></v-col
            >
            <v-col cols="12">
              <v-select
                v-if="selects[column.Name] != undefined"
                :items="selects[column.Name]"
                item-text="text"
                item-value="value"
                v-model="activeRecord[column.Name]"
                :rules="column.Nullable == '0' ? [rules.required] : []"
              ></v-select>
              <v-simple-checkbox
                v-else-if="column.Type == 'bool'"
                v-model="activeRecord[column.Name]"
                :ripple="false"
              ></v-simple-checkbox>
              <v-textarea
                v-else-if="column.Type == 'text'"
                v-model="activeRecord[column.Name]"
                class="no-detail"
                outlined
                :rules="column.Nullable == '0' ? [rules.required] : []"
                :maxlength="column.Size"
                :oninput="onInput"
                no-resize
              ></v-textarea>
              <v-text-field
                v-else-if="column.Type == 'string' || column.Type == 'int'"
                v-model="activeRecord[column.Name]"
                :rules="column.Nullable == '0' ? [rules.required] : []"
                :type="column.Type == 'string' ? 'text' : 'number'"
                :maxlength="column.Size"
                :oninput="onInput"
              ></v-text-field>
              <template v-else-if="column.Type == 'date'">
                <v-btn
                  class="form-center"
                  color="orange white--text"
                  rounded
                  @click="onClickDate(column.Name)"
                >
                  {{
                    activeRecord[column.Name] != "" && activeRecord[column.Name] != null
                      ? activeRecord[column.Name]
                      : "انتخاب تاریخ"
                  }}
                </v-btn>
                <date-picker
                  v-model="activeRecord[column.Name]"
                  :editable="false"
                  :auto-submit="true"
                  :element="'fileInput' + column.Name"
                ></date-picker>
                <v-text-field
                  v-model="activeRecord[column.Name]"
                  class="dateInput"
                  :id="'fileInput' + column.Name"
                  :ref="'fileInput' + column.Name"
                  :rules="column.Nullable == '0' ? [rules.required] : []"
                  hidden
                />
              </template>
              <template v-else-if="column.Type == 'file'">
                <v-col cols="12" v-if="activeRecord[column.Name]">
                  <div
                    v-for="file in activeRecord[column.Name]"
                    :key="file.attID"
                  >
                    <span style="direction: ltr; float: right">
                      {{ file.attName }}</span
                    >

                    <a
                      class="resume"
                      @click="$emit('removeAttach', file.attID)"
                    >
                      <font-awesome-icon icon="times" class="close-icon" />
                    </a>
                  </div>
                </v-col>
                <v-file-input
                  v-model="image"
                  accept="image/*,.pdf"
                  label="پیوست مدرک"
                  :rules="
                    column.Nullable == '0' &&
                    (activeRecord[column.Name] == null ||
                      activeRecord[column.Name].length == 0)
                      ? [rules.attach]
                      : []
                  "
                ></v-file-input>
              </template>
            </v-col>
          </template>
        </v-row>

        <v-row class="ltr">
          <v-btn
            color="primary white--text"
            class="register"
            rounded
            @click="clickButton"
            :disabled="apiRunning"
          >
            {{ apiRunning ? "لطفا منتظر بمانید..." : "ثبت" }}
          </v-btn>
        </v-row>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
export default {
  data() {
    return {
      activeRecord: {},
      selects: {},
      image: null,
      rules: {
        required: (value) => !!value || "این مقدار اجباری است.",
        attach: (value) => !!value || "الصاق پیوست اجباری است.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "ایمیل نامعتبر است.";
        },
      },
    };
  },
  props: ["columns", "keys", "record", "category"],
  computed: {
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  beforeMount() {
    if (this.record != null) {
      this.activeRecord = this.record;
    }
    for (var key in this.keys) {
      var value = this.keys[key];
      var valueArray = [];
      for (var singleValue in value) {
        var valueText = {
          value: value[singleValue].SelectId,
          text: value[singleValue].Value,
        };
        valueArray.push(valueText);
      }
      this.selects[key] = valueArray;
    }
  },

  watch: {
    record(newvalue) {
      this.activeRecord = newvalue;
    },
  },

  methods: {
    /**
     * user changed date
     */
    onClickDate(input) {
      document.getElementById("fileInput" + input).click();
    },
    clickButton() {
      if (this.$refs["form"].validate())
        this.$emit("applyRequest", this.image, this.activeRecord);
    },
  },
  /**
   * check user input and  then send khorooj request
   */
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}






.register {
  width: 300px !important;
  margin: 20px auto;
}



@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
<style>
.v-messages__message {
  display: block !important;

  text-align: right;

  font-size: 14px;
  color: red;
  line-height: 1.5 !important;
}
.dateInput .v-input__slot {
  display: none;
}
</style>
